import React from 'react';
import { Info, ArrowUp, ArrowDown } from 'lucide-react';

/**
 * Single KPI stat card — value + optional prior-period comparison,
 * optional target pill, optional info tooltip, optional TBD (unimplemented upstream) state.
 *
 * Props:
 *   label       — string
 *   value       — string | number (ignored when tbd)
 *   suffix      — string, e.g. '%' or 'h'
 *   change      — number (percent change vs previous period); sign determines arrow direction
 *   goodDirection — 'down' | 'up' — which direction of change should render green (default 'down')
 *   target      — string, e.g. '<20%'
 *   info        — string, tooltip text shown on the info icon
 *   tbd         — bool — renders a placeholder "TBD" card matching the source dashboard's unimplemented metrics
 *   tone        — 'neutral' | 'good' | 'bad' — background tint independent of `change`
 */
function MetricCard({ label, value, suffix = '', change, changeLabel = 'from previous 30 days', comparisonText, goodDirection = 'down', target, info, tbd, tone = 'neutral' }) {
  if (tbd) {
    return (
      <div className="qk-metric-card qk-metric-card--tbd">
        <div className="qk-metric-label">{label}</div>
        <div className="qk-metric-value qk-metric-value--tbd">TBD</div>
      </div>
    );
  }

  const changeIsGood = change == null ? null : goodDirection === 'down' ? change < 0 : change > 0;

  return (
    <div className={`qk-metric-card qk-metric-card--${tone}`}>
      <div className="qk-metric-label">
        {info && <Info size={13} className="qk-metric-info" title={info} />}
        {label}
      </div>
      <div className="qk-metric-value">
        {value}{suffix}
      </div>
      <div className="qk-metric-footer">
        {target && <span className="qk-metric-target">🎯 Target: {target}</span>}
        {change != null && (
          <span className={`qk-metric-change ${changeIsGood ? 'qk-metric-change--good' : 'qk-metric-change--bad'}`}>
            {change < 0 ? <ArrowDown size={12} /> : <ArrowUp size={12} />}
            {Math.abs(change)}% {changeLabel}
          </span>
        )}
        {comparisonText && <span className="qk-metric-target">{comparisonText}</span>}
      </div>
    </div>
  );
}

export function MetricCardGroup({ title, children }) {
  return (
    <div className="qk-metric-group">
      {title && <div className="qk-metric-group-title">{title}</div>}
      <div className="qk-metric-group-cards">{children}</div>
    </div>
  );
}

export default MetricCard;
